import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedPicks from './components/FeaturedPicks';
import ArticleGrid from './components/ArticleGrid';
import CTASection from './components/CTASection';
import TestimonialSection from './components/TestimonialSection';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://litbuyspreadsheets.mom';

const homeJsonLd = {
  '@type': 'WebSite',
  name: 'LitBuy Spreadsheets',
  url: siteUrl,
  description: 'Your complete guide to LitBuy spreadsheets. Expert tutorials, comparison tables, templates, and shopping guides for smart shopping and data organization.',
  inLanguage: 'en',
  potentialAction: {
    '@type': 'SearchAction',
    target: `${siteUrl}/?s={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

const organizationJsonLd = {
  '@type': 'Organization',
  name: 'LitBuy Spreadsheets',
  url: siteUrl,
  description: 'The Complete LitBuy Spreadsheet Resource Center offering expert guides, templates, and comparison tools for smarter shopping.',
  sameAs: ['https://kaspreadsheet.com/'],
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <SEOHead
        title="LitBuy Spreadsheets | The Ultimate LitBuy Spreadsheet Resource Center"
        description="Your complete guide to LitBuy spreadsheets. Expert tutorials, comparison tables, templates, and shopping guides. Learn how to use LitBuy spreadsheet for smart shopping and data organization in 2026."
        keywords="litbuy spreadsheet, litbuy spreadsheet template, litbuy spreadsheet guide, spreadsheet comparison, litbuy tracker spreadsheet, litbuy excel sheet, litbuy google sheets"
        canonicalUrl={`${siteUrl}/`}
        ogTitle="LitBuy Spreadsheets | The Ultimate LitBuy Spreadsheet Resource Center"
        ogDescription="Expert guides, templates, and tutorials for LitBuy spreadsheets. Find the best spreadsheet solutions for smart shopping."
        jsonLd={[homeJsonLd, organizationJsonLd]}
      />
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <CategoryGrid />
        <FeaturedPicks />

        <section className="w-full py-14 md:py-16 bg-background-50">
          <div className="w-full px-4 md:px-6 lg:px-8">
            <div className="max-w-3xl mx-auto text-center">
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
                What Is a LitBuy Spreadsheet?
              </h2>
              <p className="mt-4 text-foreground-600 leading-relaxed text-sm md:text-base">
                A <strong>LitBuy spreadsheet</strong> is a powerful organizational tool designed to help shoppers track prices, compare products, and make smarter purchasing decisions. Whether you are hunting for the best sneaker deals, tracking hoodie price drops, or comparing jacket styles across categories, the LitBuy spreadsheet methodology gives you a structured way to manage your shopping research. Our guides walk you through everything from basic setup to advanced comparison techniques.
              </p>
              <div className="mt-6">
                <a
                  href="/article/what-is-litbuy-spreadsheet"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all duration-200"
                >
                  Read the Full Guide
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          </div>
        </section>

        <ArticleGrid />
        <CTASection />
        <TestimonialSection />
      </main>
      <Footer />
    </div>
  );
}